import { defineStore } from "pinia";
import { cloneDeep, merge } from "lodash";
import type { roleType } from "@/types/role";
import { getRoleList } from "@/api/apiclient/application";
import { useI18n } from "vue-i18n";
import { ProfileOrganizationRoleType } from "@/types/assignee";

export const useRole = defineStore("role", {
  state: () => {
    return {
      // If the model evolves into having nested references we avoid gotchas
      current: cloneDeep({}),
      list: [] as roleType[],
    };
  },
  actions: {
    setCurrent(item: roleType): void {
      this.current = merge(this.current, item);
    },
    async loadList() {
      const list = await getRoleList();
      if (list && list.length > 0) {
        this.list = list;
      }
    },
    resetCurrent(): void {
      this.current = cloneDeep({});
    },
    resetList(): void {
      this.list = [];
    },
  },
  getters: {
    // rolesMap(): any {
    //   return this.list.reduce((acc, curr:roleType ) => {
    //     if( curr.name ){
    //       acc[curr.name] = rolesTranslations[curr.name];
    //     }
    //     return acc;
    //   }, {});
    // },
    // /**
    //  * Create a usable array for <select> components.
    //  */
    // rolesOptions: (state) =>
    //   state.list.map<{ text: string; value: number }>((role) => {
    //     return {
    //       text: rolesTranslations[role.name] ?? role.name,
    //       value: role.id,
    //     };
    //   }),
    idForRole(state): any {
      return (roleName: string) => state.list.find((role) => role.name === roleName)?.id;
    },
    getNameFromId(state) {
      return (id: number): string => {
        return state.list.find((i) => i.id == id)?.name ?? "";
      };
    },
    getTranslatedName(): any {
      return (role: string): string => {
        const { t } = useI18n();
        const raw = role;
        if (!raw) return "-";
        const key = "userRoles." + raw;
        const translated = t(key);
        return translated === key ? raw : translated; //fallback to raw if translation not found
      };
    },
    getCorrectAssigneeRoleId() {
      return (roles: ProfileOrganizationRoleType[]): number | null => {
        if (!roles || roles.length === 0) return null;
        const orderedRoles = roles.sort((a, b) => b.role_id - a.role_id);
        return (
          orderedRoles.filter((role) => role.status === "Active" && role.role_id !== 1)[0]
            ?.role_id || null
        );
      };
    },
    getCorrectAssigneeRole() {
      return (roles: ProfileOrganizationRoleType[]): ProfileOrganizationRoleType | null => {
        if (!roles || roles.length === 0) return null;
        const orderedRoles = roles.sort((a, b) => b.role_id - a.role_id);
        return (
          orderedRoles.filter((role) => role.status === "Active" && role.role_id !== 1)[0] || null
        );
      };
    },
  },
});
